import { ConfPricing, ConfTierPrice, ConfType, TransportFee } from '../order_form/OrderFormRoot';
import { OrderPaymentType, OrderPaymentTypeDetail, AcquireDataType, HomeAddressInterface, OfficeVisitInterface, ReleaseDataType, PriceType, HomeAddressInterfaceRelease } from '../types/order';
import { effectiveWeight } from '../util/effective-weight'
import toMoney from '../util/tomoney';


export class OrderData {

  info: OrderDataInfo;
  payment: OrderDataPayment;
  items: OrderDataItem[] = [];
  acquire: AcquireData;
  release: ReleaseData;
  comments: string = "";
  total: number = 0;


  constructor(clone?: OrderData) {
    if (clone) {
      this.info = new OrderDataInfo(clone.info);
      this.payment = new OrderDataPayment(clone.payment);
      this.acquire = clone.acquire.clone();
      this.release = clone.release.clone();
      this.comments = clone.comments;
      this.total = clone.total;
      this.items = [ ...clone.items ];
    } else {
      this.info = new OrderDataInfo();
      this.payment = new OrderDataPayment();
      this.acquire = new AcquireData([]);
      this.release = new ReleaseData([]);
    }
  }


  addItem(type: string, label: string, tag: string, qty: number, conf: ConfPricing, detail?: OrderDataItemData) {
    this.items.push(new OrderDataItem(type, label, tag, qty, this.info.weight, conf, detail));
  }


  get service() {
    return this.items.find(t => t.type === 'service');
  }


  get urn() {
    return this.items.find(t => t.type === 'urn');
  }


  get nameplate() {
    return this.items.find(t => t.type === 'nameplate');
  }


  get pawprint() {
    return this.items.find(t => t.type === 'pawprint');
  }


  get priority_service() {
    return this.items.find(t => t.type === 'priority_service');
  }


  get viewing_service() {
    return this.items.find(t => t.type === 'viewing_service');
  }
  
  get viewing_and_priority_service() {
    return this.items.find(t => t.type === 'viewing_and_priority_service');
  }

  get after_hours_appointment() {
    return this.items.find(t => t.type === 'after_hours_appointment');
  }
}


export class OrderDataPayment {

  type: OrderPaymentType = "later";
  type_detail: OrderPaymentTypeDetail = "invoice";
  payment_comment: string = "";
  cash_amount?: string;
  check_number?: string;


  constructor(clone?: OrderDataPayment) {
    if (clone) {
      for(const [k,v] of Object.keys(clone)) {
        (this as any)[k] = v;
      }
    }
  }

}


export class OrderDataInfo {

  pet_name: string = "";
  pet_species: string = "";
  weight: number = 0;
  owner_name: string = "";
  owner_phone: string = "";
  owner_email: string = "";

  addr_line1: string = "";
  addr_line2: string = "";
  addr_city: string = "";
  addr_state: string = "";
  addr_zip: string = "";


  constructor(clone?: OrderDataInfo) {
    if (clone) {
      for(const [k,v] of Object.entries(clone)) {
        (this as any)[k] = v;
      }
    }
  }

}


export class AcquireData {
  
  type: AcquireDataType = "home";
  fees: TransportFee[] = [];
  
  constructor(fees: TransportFee[]) {
    this.fees = fees;
  }

  clone() {
    const c = new AcquireData(this.fees);
    for(const [k,v] of Object.entries(this)) {
     (this as any)[k] = v;
    }
    return c;
  }

}


export class AcquireDataHome extends AcquireData {
  
  detail: HomeAddressInterface;
  

  constructor(detail: HomeAddressInterface, fees: TransportFee[]) {
    super(fees);
    this.type = "home";
    this.detail = detail;
  }

  clone() {
    const c = new AcquireDataHome(this.detail, this.fees);
    for(const [k,v] of Object.entries(this)) {
      (this as any)[k] = v;
    }
    return c;
  }

}


export class AcquireDataOffice extends AcquireData {
  
  detail: OfficeVisitInterface;
  
  constructor(detail: OfficeVisitInterface, fees: TransportFee[] ) {
    super(fees);
    this.type = "dropoff";
    this.detail = detail;
  }


  clone() {
    const c = new AcquireDataOffice(this.detail, this.fees);
    for(const [k,v] of Object.entries(this)) {
      (this as any)[k] = v;
    }
    return c;
  }

}


export class ReleaseData {
  
  type: ReleaseDataType = "";
  fees: TransportFee[] = [];

  constructor(fees: TransportFee[]) {
    this.fees = fees;
  }

  clone() {
    const c = new ReleaseData(this.fees);
    for(const [k,v] of Object.entries(this)) {
      (this as any)[k] = v;
    }
    return c;
  }

}


export class ReleaseDataHome extends ReleaseData {
  
  detail: HomeAddressInterfaceRelease;
  

  constructor(detail: HomeAddressInterfaceRelease, fees: TransportFee[]) {
    super(fees);
    this.type = "home";
    this.detail = detail;
  }


  clone() {
    const c = new ReleaseDataHome(this.detail, this.fees);
    for(const [k,v] of Object.entries(this)) {
      (this as any)[k] = v;
    }
    return c;
  }

}


export class ReleaseDataOffice extends ReleaseData {
  
  detail: OfficeVisitInterface;
  

  constructor(detail: OfficeVisitInterface, fees: TransportFee[]) {
    super(fees);
    this.type = "pickup";
    this.detail = detail;
  }


  clone() {
    const c = new ReleaseDataOffice(this.detail, this.fees);
    for(const [k,v] of Object.entries(this)) {
      (this as any)[k] = v;
    }
    return c;
  }

}


export class OrderDataItem {

  type: string = "";
  label: string = "";
  tag: string = "";
  price: number = 0;
  price_additional: number = 0;
  qty: number = 1;
  priceData: OrderDataItemPriceData = new OrderDataItemPriceData();
  data?: OrderDataItemData | undefined;


  constructor(type: string, label: string, tag: string, qty: number, weight: number, conf: ConfPricing, detail?: OrderDataItemData, parentOrder?: OrderData) {
    this.type = type;
    this.label = label;
    this.tag = tag;
    this.qty = qty;
    this.priceData = new OrderDataItemPriceData(weight, conf, parentOrder?.service?.tag);
    this.price = this.priceData.getTotal();
    this.price_additional = this.priceData.getTotalAdditional();

    if (detail) {
      this.data = detail;
    }
  }

}


export class OrderDataItemPriceData {


  descriptor?: string | undefined = "";
  price_per_unit?: number | undefined = 0;
  price_per_additional_unit?: number | undefined = 0;
  units?: number | undefined = 0;
  total: number = 0;
  total_additional: number = 0;
  type: PriceType = "fixed";


  constructor(weight?: number, conf?: ConfPricing, serviceTag?: string) {
    if (weight && conf) {
      this.setPricing(weight, conf, serviceTag);
    }
  }


  getTotal() {
    return this.total;
  }

  getTotalAdditional() {
    return this.total_additional;
  }


  setPricing(weight: number, pconf: ConfPricing, serviceTag?: string): void {

    weight = weight < 0 ? 0 : weight;
    const effective_weight = effectiveWeight(weight);

    this.type = pconf.pricetype;

    if (pconf.pricetype === 'fixed') {
      this.price_per_unit = pconf.price || 0;
      this.total = this.price_per_unit;

    } else if (pconf.pricetype === 'fixed_additional' && (pconf.price || pconf.price_additional)) {
      this.price_per_unit = pconf.price || 0;
      this.price_per_additional_unit = pconf.price_additional || 0;
      this.total = this.price_per_unit;
      this.total_additional = this.price_per_additional_unit || 0;

    } else if (pconf.pricetype === 'byweight' && pconf.price) {
      this.price_per_unit = pconf.price;
      this.units = effective_weight;
      this.total = pconf.price * effective_weight;
      this.descriptor = `${toMoney(pconf.price)}/lb x ${effective_weight}lbs`;

    } else if (pconf.pricetype === 'tiered' && pconf.prices) {

      let rangeBottom = 1;
      let rangeTop = 0;
      let myprice: ConfTierPrice | undefined;

      // match the price tier with the weight
      for (let i = 0; i < pconf.prices!.length; i++) {
        let pt = pconf.prices![i];
        rangeTop = pt.max ? pt.max : 0;
        if (!pt.max || effective_weight <= pt.max) {
          myprice = pt;
          let n = pconf.prices![i - 1];
          rangeBottom = (n && n.max) ? n.max + 1 : 0;

          break;
        }
      }

      if (!myprice) return;

      let rangeStr = '';
      if (rangeTop && rangeBottom) {
        rangeStr = `${rangeBottom}-${rangeTop}lbs`;
      } else if (rangeTop && !rangeBottom) {
        rangeStr = `up to ${rangeTop}lbs`;
      } else if (rangeBottom && !rangeTop) {
        rangeStr = `${rangeBottom}+lbs`;
      }

      this.total = myprice.price;
      this.descriptor = `${rangeStr}`;

    } else if (pconf.pricetype === 'service_tiered' && pconf.sprices) {

      this.price_per_unit = pconf.sprices[serviceTag || "_"] || 0;
      this.total = pconf.sprices[serviceTag || "_"] || 0;

    }
  }

}



export class OrderDataItemData {

}


export class OrderDataItemDataNamePlate extends OrderDataItemData {

  nameplate_lines: string[] = [];


  constructor(lines?: string[]) {
    super();

    if (lines) {
      this.nameplate_lines = lines;
    }
  }
  
}


export class OrderDataItemDataUrn extends OrderDataItemData {

  engraving_type: string = "";
  engraving_price: number = 0;


  constructor(type: string, price: number) {
    super();

    if (type) {
      this.engraving_type = type;
      this.engraving_price = price;
    }
  }


}

